import React from "react";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import assetPageStyle from "features/assets/styles";

const useStyles = makeStyles(assetPageStyle);

function EmptyAssetList() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.dashedBox}>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Grid item xs>
          <ArrowUpwardIcon />
        </Grid>
        <Grid item xs>
          <Typography>{t("Asset.EnterAssetNameToSearch")}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default EmptyAssetList;
